import React from "react";
import MetaComponent from "@/components/common/MetaComponent";
import Offer from "@/components/offer";

const metadata = {
  title: "Homes For Sale | Online Real Estate Auctions | Properties | Hubzu",
};

const OfferLayout = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Offer />
    </>
  );
};

export default OfferLayout;
